// extracted by mini-css-extract-plugin
export default {"editableName":"styles_editableName__9BMRa","button":"styles_button__lgwBO","icon":"styles_icon__qpt+X"};